module.exports = __webpack_public_path__ + "static/media/courtyard.a268911a.jpeg";